export const CHART_SETTINGS = {
  HEIGHT: 48,
  DATA_KEY: "price",
  GROWTH_LINE_COLOR: "#81CF1D",
  DROP_LINE_COLOR: "#FE4545",
};
